import { styled } from 'baseui'
import { COLORS } from './constants'

// ── Header (Gamification) ────────────────────────────────────────────────────

export const HeaderRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '4rem',
  marginBottom: '2rem',
  flexShrink: 0,
})

export const HeaderLeft = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  flex: 1,
})

export const Avatar = styled('img', {
  width: '4rem',
  height: '4rem',
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
})

export const NameColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
})

export const UserName = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1.875rem',
  lineHeight: 1,
  color: COLORS.textStrong,
  letterSpacing: '-0.01875rem',
})

export const DateRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
})

export const CalendarIcon = styled('img', {
  width: '1rem',
  height: '1rem',
})

export const DateText = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontSize: '0.875rem',
  color: COLORS.textMedium,
})

// ── Sections partagées ───────────────────────────────────────────────────────

export const SectionWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginBottom: '2rem',
})

export const SectionTitle = styled('h2', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '1.25rem',
  lineHeight: 1.4,
  color: COLORS.textStrong,
  margin: 0,
})

export const SectionSubtitle = styled('p', {
  fontFamily: '"Inter", sans-serif',
  fontSize: '0.875rem',
  lineHeight: 1.5,
  color: COLORS.textMedium,
  margin: 0,
})

export const SectionSubtitle2 = styled(SectionSubtitle, {
  marginTop: '-0.8rem',
  marginBottom: '1.5rem',
  textDecoration: 'underline',
  color: COLORS.blue,
  cursor: 'pointer',
})

// ── Section 1 : Niveaux en cours ─────────────────────────────────────────────

export const LevelRow = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '1.25rem',
  flexWrap: 'nowrap',
})

export const LevelItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  minWidth: '4.5rem',
})

export const LevelBadgeWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LevelChevron = styled('span', {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  userSelect: 'none',
  marginBottom: '0.75rem',
})

export const CategoryDotsRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
})

// ── Section 2 : Objectifs de vente ───────────────────────────────────────────

export const CardGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '1rem',
})

export const Card = styled('div', ({ $maxLevel }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '1rem',
  borderRadius: '0.75rem',
  backgroundColor: $maxLevel ? '#FFF5DE' : '#FFFFFF',
  border: $maxLevel ? '2px solid #D2AB68' : '1px solid #ECEEF3',
}))

export const CardTopRow = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
})

export const CardTrophyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.375rem',
  flexShrink: 0,
})

export const CardContentColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.375rem',
  flex: 1,
  minWidth: 0,
  marginTop: '1rem',
})

export const CardInfoRow = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.5rem',
})

export const CardInfoColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
})

export const CardLevelText = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontSize: '0.6875rem',
  color: '#58595B',
})

export const CardCategoryName = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '0.9375rem',
  lineHeight: 1.4,
  color: COLORS.textStrong,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const CardCounter = styled('span', {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '1rem',
  color: '#58595B',
  marginTop: '1rem',
})

export const CardProgressBar = styled('div', {
  width: '100%',
  height: '0.625rem',
  backgroundColor: COLORS.progressGray,
  borderRadius: '0.3125rem',
  overflow: 'hidden',
})

export const CardProgressFill = styled('div', ({ $width }) => ({
  width: `${$width}%`,
  height: '100%',
  backgroundColor: COLORS.progressGreen,
  borderRadius: '0.1875rem',
  transition: 'width 0.5s ease',
}))

// ── TrophyBadge ──────────────────────────────────────────────────────────────

export const TrophyContainer = styled('div', ({ $width, $height }) => ({
  position: 'relative',
  width: `${$width / 16}rem`,
  height: `${$height / 16}rem`,
  flexShrink: 0,
}))

export const LayerImg = styled('img', {
  objectFit: 'contain',
})
